/*
  Baci: keeps the cart totals honest.
  After any cart change (add, quantity, remove) has finished, compare the total shown in the
  cart drawer / cart page with the real cart. If they disagree (e.g. a slow response landed
  after a newer one, or the browser skipped an update), re-render the cart from the server.
*/
import { sectionRenderer } from '@theme/section-renderer';

const CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
const fmt = (cents) => '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const nativeFetch = window.fetch.bind(window);
let inflight = 0;
let timer = 0;

function urlOf(input) {
  if (typeof input === 'string') return input;
  if (input instanceof URL) return input.href;
  return (input && input.url) || '';
}

async function check() {
  const shown = document.querySelectorAll('.cart-totals__total-value');
  if (!shown.length) return;
  let cart;
  try {
    cart = await nativeFetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then((r) => r.json());
  } catch (e) { return; }
  if (inflight > 0) return; // another change started meanwhile; we'll check again after it
  const expected = fmt(cart.total_price);
  const stale = Array.from(shown).some((el) => el.textContent.trim() !== expected);
  if (!stale) return;
  document.querySelectorAll('cart-items-component[data-section-id]').forEach((el) => {
    try { sectionRenderer.renderSection(el.dataset.sectionId, { cache: false }); } catch (e) {}
  });
}

function schedule() {
  clearTimeout(timer);
  timer = setTimeout(check, 600);
}

window.fetch = function (input, init) {
  const url = urlOf(input).split('#')[0];
  const method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
  if (method !== 'POST' || !CART_WRITE.test(url)) return nativeFetch(input, init);
  inflight++;
  clearTimeout(timer);
  const p = nativeFetch(input, init);
  p.finally(() => { inflight = Math.max(0, inflight - 1); if (inflight === 0) schedule(); }).catch(() => {});
  return p;
};

document.addEventListener('cart:update', schedule);
